import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface AddLayerButtonProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  tooManySelected: boolean;
}

export default function AddLayerButton({
  isOpen,
  setIsOpen,
  tooManySelected,
}: AddLayerButtonProps): JSX.Element {
  return (
    <div className={css(styles.wrapper)}>
      <Button
        buttonStyle={ButtonStyle.TEXT}
        disabled={tooManySelected}
        icon="plus"
        iconAltText="Add"
        onClick={() => {
          if (!tooManySelected) {
            setIsOpen(!isOpen);
          }
        }}
        size={ButtonSize.MINI}
        text="Add"
      />
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
  },
});
